import React from 'react';

import { Switch } from '@/components/ui/switch';

interface IProps {
  showPlannedRoute: boolean;
  showAnalyzedTrace: boolean;
  onPlannedRouteChange: (checked: boolean) => void;
  onAnalyzedTraceChange: (checked: boolean) => void;
}

const ActingRouteLayerControls: React.FC<IProps> = ({
  showPlannedRoute,
  showAnalyzedTrace,
  onPlannedRouteChange,
  onAnalyzedTraceChange,
}) => (
  <div className="flex flex-wrap gap-4" aria-label="Camadas do mapa">
    <label className="flex items-center gap-2 text-sm">
      <Switch
        aria-label="Exibir rota planejada"
        checked={showPlannedRoute}
        onCheckedChange={onPlannedRouteChange}
      />
      Rota planejada
    </label>
    <label className="flex items-center gap-2 text-sm">
      <Switch
        aria-label="Exibir traçado analisado"
        checked={showAnalyzedTrace}
        onCheckedChange={onAnalyzedTraceChange}
      />
      Traçado analisado
    </label>
  </div>
);

export default ActingRouteLayerControls;
